module.exports = __webpack_public_path__ + "img/b-purple@2x.0eea6b25.png";